import React from "react";
import { Activity } from "lucide-react";

import { CATEGORY_ICON_MAP } from "../utils/utils";

type FindingsFiltersProps = {
  categories: string[];
  selectedCategories: string[];
  t: (key: string, options?: Record<string, unknown>) => string;
  onClearAll: () => void;
  onToggleCategory: (category: string) => void;
};

const FilterIcon = ({ category }: { category: string }) => {
  const icon = CATEGORY_ICON_MAP[category];
  if (!icon) {
    return <Activity size={16} className="text-slate-600 dark:text-gray-400" />;
  }

  return (
    <img
      src={icon}
      alt={category}
      width={16}
      height={16}
      className="object-contain"
    />
  );
};

export const FindingsFilters = ({
  categories,
  selectedCategories,
  t,
  onClearAll,
  onToggleCategory,
}: FindingsFiltersProps) => (
  <div className="flex-shrink-0 bg-white dark:bg-gray-800 rounded-xl border border-slate-200 dark:border-gray-700 p-4 shadow-sm space-y-4 mb-6 mx-4">
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-medium text-slate-700 dark:text-gray-300">{t("filters.filterByCategory")}</h3>
        {selectedCategories.length > 0 && (
          <button
            onClick={onClearAll}
            className="text-xs text-slate-500 dark:text-gray-400 hover:text-slate-700 dark:hover:text-gray-300 flex items-center gap-1"
          >
            <Activity size={12} />
            {t("filters.clearAll")}
          </button>
        )}
      </div>

      <div className="flex flex-wrap gap-2">
        {categories.map((category) => (
          <button
            key={category}
            onClick={() => onToggleCategory(category)}
            className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium transition-all ${selectedCategories.includes(category)
              ? "bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 border border-blue-200 dark:border-blue-700"
              : "bg-slate-50 dark:bg-gray-700 text-slate-600 dark:text-gray-300 border border-slate-200 dark:border-gray-600 hover:bg-slate-100 dark:hover:bg-gray-600"
              }`}
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <FilterIcon category={category} />
            </div>
            {category}
          </button>
        ))}
      </div>
    </div>
  </div>
);
